module.exports = __webpack_public_path__ + "static/media/MEMBERS_ONLY_EVENTS_60X50.c1000ec1.svg";